import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Session } from '@models/Sessions/Session';
import _ from 'lodash';

@Component({
  selector: 'app-team-page',
  templateUrl: './team-page.component.html',
  styleUrls: ['./team-page.component.scss'],
})
export class SessionModulesTeamPageComponent implements OnInit, AfterViewInit {
  @Input() session: Session;
  @Input() teamsDict: any;

  orderedTeams = [];
  coordinates = []; // hexagon center points on canvas

  constructor(private changeDetector: ChangeDetectorRef) {}

  calculateTeams() {
    // this.changeDetector.markForCheck();
    _.forEach(this.session.scores.teams, (value, key) => {
      this.orderedTeams.push({
        id: key,
        name: this.teamsDict[key].name,
        scores: value,
      });
    });

    /*
     * Teams
     *   [1] [4]
     * [5]     [6]
     *   [3] [2]
     * */

    this.coordinates[0] = { x: 0, y: 0 };
    this.coordinates[1] = { x: 192, y: 64 };
    this.coordinates[5] = { x: 84, y: 252 };
    this.coordinates[3] = { x: 192, y: 438 };
    this.coordinates[4] = { x: 411, y: 64 };
    this.coordinates[6] = { x: 523, y: 252 };
    this.coordinates[2] = { x: 411, y: 438 };
  }

  drawConnection(start, end, strength) {
    const c = document.getElementById('teamCanvas') as HTMLCanvasElement;
    const ctx = c.getContext('2d');
    ctx.beginPath();
    ctx.moveTo(start.x, start.y);
    ctx.lineTo(end.x, end.y);
    ctx.lineWidth = strength || 1;
    ctx.strokeStyle = '#53BBB3';

    if (strength > 0) {
      ctx.stroke();
    }
  }

  calculateStrength(firstTeamId: number, secondTeamId: number) {
    const scores = this.session.scores.interactions[firstTeamId][secondTeamId];
    return Math.max(
      scores.challenger +
        scores.improver_number +
        scores.improver_total +
        scores.solution_finder +
        scores.sunshine,
      0,
    );
  }

  drawConnections() {
    for (let i = 0; i < this.coordinates.length - 1; i++) {
      for (let ii = i + 1; ii < this.coordinates.length - 1; ii++) {
        if (this.orderedTeams[ii]) {
          this.drawConnection(
            this.coordinates[i + 1],
            this.coordinates[ii + 1],
            this.calculateStrength(
              this.orderedTeams[i].id,
              this.orderedTeams[ii].id,
            ),
          );
        }
      }
    }
  }

  calculateTopscorer(total, number) {
    return {
      performance:
        Math.max(parseInt(number > 0 ? total / number : total, 10) * 4, 2) +
        'px',
      activity: Math.max(Math.min(parseInt(number, 10), 10) * 4, 2) + 'px',
    };
  }

  calculateSparkcreator(total, number) {
    return {
      performance:
        Math.max(parseInt(number > 0 ? total / number : total, 10) * 4, 2) +
        'px',
      activity: Math.max(Math.min(parseInt(number, 10), 10) * 4, 2) + 'px',
    };
  }

  calculateImprover(total, number) {
    return {
      performance:
        Math.max(parseInt(number > 0 ? total / number : total, 10) * 4, 2) +
        'px',
      activity: Math.max(Math.min(parseInt(number, 10), 10) * 4, 2) + 'px',
    };
  }

  calculateChallenger(number) {
    return {
      performance: Math.max(Math.min(parseInt(number, 10), 10) * 4, 2) + 'px',
      activity: Math.max(Math.min(parseInt(number, 10), 10) * 4, 2) + 'px',
    };
  }

  calculateSunshine(number) {
    return {
      performance: Math.max(Math.min(parseInt(number, 10), 10) * 4, 2) + 'px',
      activity: Math.max(Math.min(parseInt(number, 10), 10) * 4, 2) + 'px',
    };
  }

  calculateSolutionfinder(number) {
    return {
      performance: Math.max(Math.min(parseInt(number, 10), 10) * 4, 2) + 'px',
      activity: Math.max(Math.min(parseInt(number, 10), 10) * 4, 2) + 'px',
    };
  }

  ngOnInit() {
    this.calculateTeams();
  }

  ngAfterViewInit() {
    this.drawConnections();
  }
}
